export const snakeCase = (data) => {
    if (typeof data !== 'object' || data === null || data === undefined || data instanceof File) {
        return data;
    }

    if (Array.isArray(data)) {
        return data.map(item => snakeCase(item));
    }

    return Object.entries(data).reduce((acc, [key, value]) => {
        const snakeKey = key.replace(/([A-Z])/g, "_$1").toLowerCase();
        acc[snakeKey] = snakeCase(value);
        return acc;
    }, {});
}